import PhotoSwipeLightbox from "/resources/js/libs/photoswipe/dist/photoswipe-lightbox.esm.js";

const PhotoSwipeLightboxOptions = {
    gallerySelector: ".img-galleries",
    childSelector: "a.img-popup",
    pswpModule: "/resources/js/libs/photoswipe/dist/photoswipe.esm.js"
};
const lightbox = new PhotoSwipeLightbox(PhotoSwipeLightboxOptions);
lightbox.on('uiRegister', function () {
    lightbox.pswp.ui.registerElement({
        name: 'custom-caption',
        order: 9,
        isButton: false,
        appendTo: 'root',
        html: 'Caption text',
        onInit: (el, pswp) => {
            lightbox.pswp.on('change', () => {
                const currSlideElement = lightbox.pswp.currSlide.data.element;
                let captionHTML = '';
                if (currSlideElement) {
                    captionHTML = currSlideElement.querySelector('img').getAttribute('alt');
                }
                el.innerHTML = captionHTML || '';
            });
        }
    });
});
lightbox.init();